import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from 'src/app/components/base.component';
import { SharedService } from 'src/app/services/sharedService';

@Component({
  selector: 'app-shapefile-mapping-form',
  templateUrl: './shapefile-mapping-form.component.html',
  styleUrls: ['./shapefile-mapping-form.component.css']
})
export class ShapefileMappingFormComponent extends BaseComponent implements OnInit {
  constructor(private sharedService: SharedService) { super() }
  @Input() attributes
  lot
  ngOnInit(): void {
    this.sharedService.formSaveSubject$.pipe(takeUntil(this.destroy$)).subscribe(
      () => {
        this.sharedService.addShapefileMapping(this.lot)
      }
    )
  }

}
